import { selectOption } from "src/types/wizard"

// Option values are the exact option texts of the China visa application form so the engine can select them directly.
export const CN_PROVINCES: selectOption[] = [
  { label: "HeNan", value: "HeNan" },
  { label: "ShaanXi", value: "ShaanXi" },
  { label: "TianJin", value: "TianJin" },
  { label: "HeBei", value: "HeBei" },
  { label: "TaiWan", value: "TaiWan" },
  { label: "ShanXi", value: "ShanXi" },
  { label: "NeiMengGu", value: "NeiMengGu" },
  { label: "LiaoNing", value: "LiaoNing" },
  { label: "JiLin", value: "JiLin" },
  { label: "HeiLongJiang", value: "HeiLongJiang" },
  { label: "ShangHai", value: "ShangHai" },
  { label: "JiangSu", value: "JiangSu" },
  { label: "ZheJiang", value: "ZheJiang" },
  { label: "AnHui", value: "AnHui" },
  { label: "FuJian", value: "FuJian" },
  { label: "JiangXi", value: "JiangXi" },
  { label: "ShanDong", value: "ShanDong" },
  { label: "HuBei", value: "HuBei" },
  { label: "HuNan", value: "HuNan" },
  { label: "GuangDong", value: "GuangDong" },
  { label: "GuangXi", value: "GuangXi" },
  { label: "HaiNan", value: "HaiNan" },
  { label: "ChongQing", value: "ChongQing" },
  { label: "SiChuan", value: "SiChuan" },
  { label: "GuiZhou", value: "GuiZhou" },
  { label: "YunNan", value: "YunNan" },
  { label: "NingXia", value: "NingXia" },
  { label: "GanSu", value: "GanSu" },
  { label: "QingHai", value: "QingHai" },
  { label: "XinJiang", value: "XinJiang" },
  { label: "HongKong", value: "HongKong" },
  { label: "MaCao", value: "MaCao" },
  { label: "BeiJing", value: "BeiJing" },
  { label: "XiZang", value: "XiZang" }
]

export const CN_CITIES: selectOption[] = [
  { label: "Aba (SiChuan)", value: "SiChuan,Aba" },
  { label: "Aksu (XinJiang)", value: "XinJiang,Aksu" },
  { label: "alaer Shi (XinJiang)", value: "XinJiang,alaer Shi" },
  { label: "Altay (XinJiang)", value: "XinJiang,Altay" },
  { label: "Alxa Meng (NeiMengGu)", value: "NeiMengGu,Alxa Meng" },
  { label: "AnKang (ShaanXi)", value: "ShaanXi,AnKang" },
  { label: "Anqing (AnHui)", value: "AnHui,Anqing" },
  { label: "Anshan (LiaoNing)", value: "LiaoNing,Anshan" },
  { label: "Anshun (GuiZhou)", value: "GuiZhou,Anshun" },
  { label: "Anyang (HeNan)", value: "HeNan,Anyang" },
  { label: "Baicheng (JiLin)", value: "JiLin,Baicheng" },
  { label: "Baisha Lizu Zizhixian (HaiNan)", value: "HaiNan,Baisha Lizu Zizhixian" },
  { label: "Baishan (JiLin)", value: "JiLin,Baishan" },
  { label: "baiyang Shi (XinJiang)", value: "XinJiang,baiyang Shi" },
  { label: "Baiyin (GanSu)", value: "GanSu,Baiyin" },
  { label: "Baoding (HeBei)", value: "HeBei,Baoding" },
  { label: "Baoji (ShaanXi)", value: "ShaanXi,Baoji" },
  { label: "Baoshan (YunNan)", value: "YunNan,Baoshan" },
  { label: "Baoting Lizu Miaozu Zizhixian (HaiNan)", value: "HaiNan,Baoting Lizu Miaozu Zizhixian" },
  { label: "Baotou (NeiMengGu)", value: "NeiMengGu,Baotou" },
  { label: "Bayannur (NeiMengGu)", value: "NeiMengGu,Bayannur" },
  { label: "Bayingolin Mongol (XinJiang)", value: "XinJiang,Bayingolin Mongol" },
  { label: "Bazhong (SiChuan)", value: "SiChuan,Bazhong" },
  { label: "Beihai (GuangXi)", value: "GuangXi,Beihai" },
  { label: "Beijing (BeiJing)", value: "BeiJing,Beijing" },
  { label: "beitun Shi (XinJiang)", value: "XinJiang,beitun Shi" },
  { label: "Bengbu (AnHui)", value: "AnHui,Bengbu" },
  { label: "Benxi (LiaoNing)", value: "LiaoNing,Benxi" },
  { label: "Bijie (GuiZhou)", value: "GuiZhou,Bijie" },
  { label: "Binzhou (ShanDong)", value: "ShanDong,Binzhou" },
  { label: "Bortala Mongol (XinJiang)", value: "XinJiang,Bortala Mongol" },
  { label: "Bose (GuangXi)", value: "GuangXi,Bose" },
  { label: "Bozhou (AnHui)", value: "AnHui,Bozhou" },
  { label: "Cangzhou (HeBei)", value: "HeBei,Cangzhou" },
  { label: "Changchun (JiLin)", value: "JiLin,Changchun" },
  { label: "Changde (HuNan)", value: "HuNan,Changde" },
  { label: "Changji (XinJiang)", value: "XinJiang,Changji" },
  { label: "Changjiang Lizu Zizhixian (HaiNan)", value: "HaiNan,Changjiang Lizu Zizhixian" },
  { label: "Changsha (HuNan)", value: "HuNan,Changsha" },
  { label: "Changzhi (ShanXi)", value: "ShanXi,Changzhi" },
  { label: "Changzhou (JiangSu)", value: "JiangSu,Changzhou" },
  { label: "Chaoyang (LiaoNing)", value: "LiaoNing,Chaoyang" },
  { label: "Chaozhou (GuangDong)", value: "GuangDong,Chaozhou" },
  { label: "Chengde (HeBei)", value: "HeBei,Chengde" },
  { label: "Chengdu (SiChuan)", value: "SiChuan,Chengdu" },
  { label: "Chengmai Qu (HaiNan)", value: "HaiNan,Chengmai Qu" },
  { label: "Chenzhou (HuNan)", value: "HuNan,Chenzhou" },
  { label: "Chifeng (NeiMengGu)", value: "NeiMengGu,Chifeng" },
  { label: "Chizhou (AnHui)", value: "AnHui,Chizhou" },
  { label: "Chongqing (ChongQing)", value: "ChongQing,Chongqing" },
  { label: "Chongzuo (GuangXi)", value: "GuangXi,Chongzuo" },
  { label: "Chuxiong (YunNan)", value: "YunNan,Chuxiong" },
  { label: "Chuzhou (AnHui)", value: "AnHui,Chuzhou" },
  { label: "Da Hinggan Ling (HeiLongJiang)", value: "HeiLongJiang,Da Hinggan Ling" },
  { label: "Dali (YunNan)", value: "YunNan,Dali" },
  { label: "Dalian (LiaoNing)", value: "LiaoNing,Dalian" },
  { label: "Dandong (LiaoNing)", value: "LiaoNing,Dandong" },
  { label: "Danzhou Shi (HaiNan)", value: "HaiNan,Danzhou Shi" },
  { label: "Daqing (HeiLongJiang)", value: "HeiLongJiang,Daqing" },
  { label: "Datong (ShanXi)", value: "ShanXi,Datong" },
  { label: "Dazhou (SiChuan)", value: "SiChuan,Dazhou" },
  { label: "Dehong (YunNan)", value: "YunNan,Dehong" },
  { label: "Dêqên (YunNan)", value: "YunNan,Dêqên" },
  { label: "Deyang (SiChuan)", value: "SiChuan,Deyang" },
  { label: "Dezhou (ShanDong)", value: "ShanDong,Dezhou" },
  { label: "Dingan Xian (HaiNan)", value: "HaiNan,Dingan Xian" },
  { label: "Dingxi (GanSu)", value: "GanSu,Dingxi" },
  { label: "Dongfang  Shi (HaiNan)", value: "HaiNan,Dongfang  Shi" },
  { label: "Dongguan (GuangDong)", value: "GuangDong,Dongguan" },
  { label: "Dongying (ShanDong)", value: "ShanDong,Dongying" },
  { label: "Enshi (HuBei)", value: "HuBei,Enshi" },
  { label: "Ezhou (HuBei)", value: "HuBei,Ezhou" },
  { label: "Fangchenggang (GuangXi)", value: "GuangXi,Fangchenggang" },
  { label: "Foshan (GuangDong)", value: "GuangDong,Foshan" },
  { label: "Fushun (LiaoNing)", value: "LiaoNing,Fushun" },
  { label: "Fuxin (LiaoNing)", value: "LiaoNing,Fuxin" },
  { label: "Fuyang (AnHui)", value: "AnHui,Fuyang" },
  { label: "Fuzhou (JiangXi)", value: "JiangXi,Fuzhou" },
  { label: "Fuzhou (FuJian)", value: "FuJian,Fuzhou" },
  { label: "Gannan (GanSu)", value: "GanSu,Gannan" },
  { label: "Ganzhou (JiangXi)", value: "JiangXi,Ganzhou" },
  { label: "Gaoxiong (TaiWan)", value: "TaiWan,Gaoxiong" },
  { label: "Garzê (SiChuan)", value: "SiChuan,Garzê" },
  { label: "Golog (QingHai)", value: "QingHai,Golog" },
  { label: "Guangan (SiChuan)", value: "SiChuan,Guangan" },
  { label: "Guangyuan (SiChuan)", value: "SiChuan,Guangyuan" },
  { label: "Guangzhou (GuangDong)", value: "GuangDong,Guangzhou" },
  { label: "Guigang (GuangXi)", value: "GuangXi,Guigang" },
  { label: "Guilin (GuangXi)", value: "GuangXi,Guilin" },
  { label: "Guiyang (GuiZhou)", value: "GuiZhou,Guiyang" },
  { label: "Guyuan (NingXia)", value: "NingXia,Guyuan" },
  { label: "Haibei (QingHai)", value: "QingHai,Haibei" },
  { label: "Haidong (QingHai)", value: "QingHai,Haidong" },
  { label: "Haikou (HaiNan)", value: "HaiNan,Haikou" },
  { label: "Hainan (QingHai)", value: "QingHai,Hainan" },
  { label: "Haixi (QingHai)", value: "QingHai,Haixi" },
  { label: "Hami (XinJiang)", value: "XinJiang,Hami" },
  { label: "Handan (HeBei)", value: "HeBei,Handan" },
  { label: "Hangzhou (ZheJiang)", value: "ZheJiang,Hangzhou" },
  { label: "Hanzhong (ShaanXi)", value: "ShaanXi,Hanzhong" },
  { label: "Harbin (HeiLongJiang)", value: "HeiLongJiang,Harbin" },
  { label: "Hebi (HeNan)", value: "HeNan,Hebi" },
  { label: "Hechi (GuangXi)", value: "GuangXi,Hechi" },
  { label: "Hefei (AnHui)", value: "AnHui,Hefei" },
  { label: "Hegang (HeiLongJiang)", value: "HeiLongJiang,Hegang" },
  { label: "Heihe (HeiLongJiang)", value: "HeiLongJiang,Heihe" },
  { label: "Hengshui (HeBei)", value: "HeBei,Hengshui" },
  { label: "Hengyang (HuNan)", value: "HuNan,Hengyang" },
  { label: "Heyuan (GuangDong)", value: "GuangDong,Heyuan" },
  { label: "Heze (ShanDong)", value: "ShanDong,Heze" },
  { label: "Hezhou (GuangXi)", value: "GuangXi,Hezhou" },
  { label: "Hohhot (NeiMengGu)", value: "NeiMengGu,Hohhot" },
  { label: "Honghe (YunNan)", value: "YunNan,Honghe" },
  { label: "Hongkong Island (HongKong)", value: "HongKong,Hongkong Island" },
  { label: "Hotan (XinJiang)", value: "XinJiang,Hotan" },
  { label: "Huai'an (JiangSu)", value: "JiangSu,Huai'an" },
  { label: "Huaibei (AnHui)", value: "AnHui,Huaibei" },
  { label: "Huaihua (HuNan)", value: "HuNan,Huaihua" },
  { label: "Huainan (AnHui)", value: "AnHui,Huainan" },
  { label: "Hualian (TaiWan)", value: "TaiWan,Hualian" },
  { label: "Huanggang (HuBei)", value: "HuBei,Huanggang" },
  { label: "Huangnan (QingHai)", value: "QingHai,Huangnan" },
  { label: "Huangshan (AnHui)", value: "AnHui,Huangshan" },
  { label: "Huangshi (HuBei)", value: "HuBei,Huangshi" },
  { label: "Huizhou (GuangDong)", value: "GuangDong,Huizhou" },
  { label: "Huludao (LiaoNing)", value: "LiaoNing,Huludao" },
  { label: "Hulun Buir (NeiMengGu)", value: "NeiMengGu,Hulun Buir" },
  { label: "huyanghe Shi (XinJiang)", value: "XinJiang,huyanghe Shi" },
  { label: "Huzhou (ZheJiang)", value: "ZheJiang,Huzhou" },
  { label: "Ili Kazak (XinJiang)", value: "XinJiang,Ili Kazak" },
  { label: "Ji'an (JiangXi)", value: "JiangXi,Ji'an" },
  { label: "Jiamusi (HeiLongJiang)", value: "HeiLongJiang,Jiamusi" },
  { label: "Jiangmen (GuangDong)", value: "GuangDong,Jiangmen" },
  { label: "Jiaozuo (HeNan)", value: "HeNan,Jiaozuo" },
  { label: "Jiaxing (ZheJiang)", value: "ZheJiang,Jiaxing" },
  { label: "Jiayi (TaiWan)", value: "TaiWan,Jiayi" },
  { label: "Jiayuguan (GanSu)", value: "GanSu,Jiayuguan" },
  { label: "Jieyang (GuangDong)", value: "GuangDong,Jieyang" },
  { label: "Jilin (JiLin)", value: "JiLin,Jilin" },
  { label: "Jilong (TaiWan)", value: "TaiWan,Jilong" },
  { label: "Jinan (ShanDong)", value: "ShanDong,Jinan" },
  { label: "Jinchang (GanSu)", value: "GanSu,Jinchang" },
  { label: "Jincheng (ShanXi)", value: "ShanXi,Jincheng" },
  { label: "Jingdezhen (JiangXi)", value: "JiangXi,Jingdezhen" },
  { label: "Jingmen (HuBei)", value: "HuBei,Jingmen" },
  { label: "Jingzhou (HuBei)", value: "HuBei,Jingzhou" },
  { label: "Jinhua (ZheJiang)", value: "ZheJiang,Jinhua" },
  { label: "Jining (ShanDong)", value: "ShanDong,Jining" },
  { label: "Jinzhong (ShanXi)", value: "ShanXi,Jinzhong" },
  { label: "Jinzhou (LiaoNing)", value: "LiaoNing,Jinzhou" },
  { label: "Jiujiang (JiangXi)", value: "JiangXi,Jiujiang" },
  { label: "Jiulong (HongKong)", value: "HongKong,Jiulong" },
  { label: "Jiuquan (GanSu)", value: "GanSu,Jiuquan" },
  { label: "Jixi (HeiLongJiang)", value: "HeiLongJiang,Jixi" },
  { label: "Jiyuan (HeNan)", value: "HeNan,Jiyuan" },
  { label: "Kaifeng (HeNan)", value: "HeNan,Kaifeng" },
  { label: "Karamay (XinJiang)", value: "XinJiang,Karamay" },
  { label: "Kashi (XinJiang)", value: "XinJiang,Kashi" },
  { label: "kekedala Shi (XinJiang)", value: "XinJiang,kekedala Shi" },
  { label: "Kizilsu Kirgiz (XinJiang)", value: "XinJiang,Kizilsu Kirgiz" },
  { label: "Kunming (YunNan)", value: "YunNan,Kunming" },
  { label: "kunyu Shi (XinJiang)", value: "XinJiang,kunyu Shi" },
  { label: "Laibin (GuangXi)", value: "GuangXi,Laibin" },
  { label: "Langfang (HeBei)", value: "HeBei,Langfang" },
  { label: "Lanzhou (GanSu)", value: "GanSu,Lanzhou" },
  { label: "Ledong Lizu Zizhixian (HaiNan)", value: "HaiNan,Ledong Lizu Zizhixian" },
  { label: "Leshan (SiChuan)", value: "SiChuan,Leshan" },
  { label: "Lhasa (XiZang)", value: "XiZang,Lhasa" },
  { label: "Liangshan (SiChuan)", value: "SiChuan,Liangshan" },
  { label: "Lianyungang (JiangSu)", value: "JiangSu,Lianyungang" },
  { label: "Liaocheng (ShanDong)", value: "ShanDong,Liaocheng" },
  { label: "Liaoyang (LiaoNing)", value: "LiaoNing,Liaoyang" },
  { label: "Liaoyuan (JiLin)", value: "JiLin,Liaoyuan" },
  { label: "Lijiang (YunNan)", value: "YunNan,Lijiang" },
  { label: "Lincang (YunNan)", value: "YunNan,Lincang" },
  { label: "Linfen (ShanXi)", value: "ShanXi,Linfen" },
  { label: "Lingao Xian (HaiNan)", value: "HaiNan,Lingao Xian" },
  { label: "Lingshui Lizu Zizhixian (HaiNan)", value: "HaiNan,Lingshui Lizu Zizhixian" },
  { label: "Linxia (GanSu)", value: "GanSu,Linxia" },
  { label: "Linyi (ShanDong)", value: "ShanDong,Linyi" },
  { label: "Linzhi Shi (XiZang)", value: "XiZang,Linzhi Shi" },
  { label: "Lishui (ZheJiang)", value: "ZheJiang,Lishui" },
  { label: "Liupanshui (GuiZhou)", value: "GuiZhou,Liupanshui" },
  { label: "Liuzhou (GuangXi)", value: "GuangXi,Liuzhou" },
  { label: "Longnan (GanSu)", value: "GanSu,Longnan" },
  { label: "Longyan (FuJian)", value: "FuJian,Longyan" },
  { label: "Loudi (HuNan)", value: "HuNan,Loudi" },
  { label: "Lu'an (AnHui)", value: "AnHui,Lu'an" },
  { label: "Lüliang (ShanXi)", value: "ShanXi,Lüliang" },
  { label: "Luohe (HeNan)", value: "HeNan,Luohe" },
  { label: "Luoyang (HeNan)", value: "HeNan,Luoyang" },
  { label: "Luzhou (SiChuan)", value: "SiChuan,Luzhou" },
  { label: "Ma'anshan (AnHui)", value: "AnHui,Ma'anshan" },
  { label: "Macao (MaCao)", value: "MaCao,Macao" },
  { label: "Maoming (GuangDong)", value: "GuangDong,Maoming" },
  { label: "Meishan (SiChuan)", value: "SiChuan,Meishan" },
  { label: "Meizhou (GuangDong)", value: "GuangDong,Meizhou" },
  { label: "Mianyang (SiChuan)", value: "SiChuan,Mianyang" },
  { label: "Miaosu (TaiWan)", value: "TaiWan,Miaosu" },
  { label: "MudanJiang (HeiLongJiang)", value: "HeiLongJiang,MudanJiang" },
  { label: "Nagqu (XiZang)", value: "XiZang,Nagqu" },
  { label: "Nanchang (JiangXi)", value: "JiangXi,Nanchang" },
  { label: "Nanchong (SiChuan)", value: "SiChuan,Nanchong" },
  { label: "Nanjing (JiangSu)", value: "JiangSu,Nanjing" },
  { label: "Nanning (GuangXi)", value: "GuangXi,Nanning" },
  { label: "Nanping (FuJian)", value: "FuJian,Nanping" },
  { label: "Nansha (HaiNan)", value: "HaiNan,Nansha" },
  { label: "Nantong (JiangSu)", value: "JiangSu,Nantong" },
  { label: "Nantou (TaiWan)", value: "TaiWan,Nantou" },
  { label: "Nanyang (HeNan)", value: "HeNan,Nanyang" },
  { label: "Neijiang (SiChuan)", value: "SiChuan,Neijiang" },
  { label: "Ngari (XiZang)", value: "XiZang,Ngari" },
  { label: "Ningbo (ZheJiang)", value: "ZheJiang,Ningbo" },
  { label: "Ningde (FuJian)", value: "FuJian,Ningde" },
  { label: "Nujiang (YunNan)", value: "YunNan,Nujiang" },
  { label: "Ordos (NeiMengGu)", value: "NeiMengGu,Ordos" },
  { label: "Panjin (LiaoNing)", value: "LiaoNing,Panjin" },
  { label: "Panzhihua (SiChuan)", value: "SiChuan,Panzhihua" },
  { label: "Penghu (TaiWan)", value: "TaiWan,Penghu" },
  { label: "Pingdingshan (HeNan)", value: "HeNan,Pingdingshan" },
  { label: "Pingdong (TaiWan)", value: "TaiWan,Pingdong" },
  { label: "Pingliang (GanSu)", value: "GanSu,Pingliang" },
  { label: "Pingxiang (JiangXi)", value: "JiangXi,Pingxiang" },
  { label: "Pu'er (YunNan)", value: "YunNan,Pu'er" },
  { label: "Putian (FuJian)", value: "FuJian,Putian" },
  { label: "Puyang (HeNan)", value: "HeNan,Puyang" },
  { label: "Qamdo (XiZang)", value: "XiZang,Qamdo" },
  { label: "Qiandongnan (GuiZhou)", value: "GuiZhou,Qiandongnan" },
  { label: "Qianjiang (HuBei)", value: "HuBei,Qianjiang" },
  { label: "Qiannan (GuiZhou)", value: "GuiZhou,Qiannan" },
  { label: "Qianxinan (GuiZhou)", value: "GuiZhou,Qianxinan" },
  { label: "Qianxi Shi (GuiZhou)", value: "GuiZhou,Qianxi Shi" },
  { label: "Qingdao (ShanDong)", value: "ShanDong,Qingdao" },
  { label: "Qingyang (GanSu)", value: "GanSu,Qingyang" },
  { label: "Qingyuan (GuangDong)", value: "GuangDong,Qingyuan" },
  { label: "Qinhuangdao (HeBei)", value: "HeBei,Qinhuangdao" },
  { label: "Qinzhou (GuangXi)", value: "GuangXi,Qinzhou" },
  { label: "Qionghai   Shi (HaiNan)", value: "HaiNan,Qionghai   Shi" },
  { label: "Qiongzhong Lizu Miaozu Zizhixian (HaiNan)", value: "HaiNan,Qiongzhong Lizu Miaozu Zizhixian" },
  { label: "Qiqihar (HeiLongJiang)", value: "HeiLongJiang,Qiqihar" },
  { label: "QitaiHe (HeiLongJiang)", value: "HeiLongJiang,QitaiHe" },
  { label: "Quanzhou (FuJian)", value: "FuJian,Quanzhou" },
  { label: "Qujing (YunNan)", value: "YunNan,Qujing" },
  { label: "Quzhou (ZheJiang)", value: "ZheJiang,Quzhou" },
  { label: "Rizhao (ShanDong)", value: "ShanDong,Rizhao" },
  { label: "Sanmenxia (HeNan)", value: "HeNan,Sanmenxia" },
  { label: "Sanming (FuJian)", value: "FuJian,Sanming" },
  { label: "Sanya (HaiNan)", value: "HaiNan,Sanya" },
  { label: "Shanghai (ShangHai)", value: "ShangHai,Shanghai" },
  { label: "Shangluo (ShaanXi)", value: "ShaanXi,Shangluo" },
  { label: "Shangqiu (HeNan)", value: "HeNan,Shangqiu" },
  { label: "Shangrao (JiangXi)", value: "JiangXi,Shangrao" },
  { label: "Shannan (XiZang)", value: "XiZang,Shannan" },
  { label: "Shantou (GuangDong)", value: "GuangDong,Shantou" },
  { label: "Shanwei (GuangDong)", value: "GuangDong,Shanwei" },
  { label: "Shaoguan (GuangDong)", value: "GuangDong,Shaoguan" },
  { label: "Shaoxing (ZheJiang)", value: "ZheJiang,Shaoxing" },
  { label: "Shaoyang (HuNan)", value: "HuNan,Shaoyang" },
  { label: "Shennongjia (HuBei)", value: "HuBei,Shennongjia" },
  { label: "Shenyang (LiaoNing)", value: "LiaoNing,Shenyang" },
  { label: "Shenzhen (GuangDong)", value: "GuangDong,Shenzhen" },
  { label: "Shihezi Shi (XinJiang)", value: "XinJiang,Shihezi Shi" },
  { label: "Shijiazhuang (HeBei)", value: "HeBei,Shijiazhuang" },
  { label: "Shiyan (HuBei)", value: "HuBei,Shiyan" },
  { label: "Shizuishan (NingXia)", value: "NingXia,Shizuishan" },
  { label: "shuanghe Shi (XinJiang)", value: "XinJiang,shuanghe Shi" },
  { label: "ShuangyaShan (HeiLongJiang)", value: "HeiLongJiang,ShuangyaShan" },
  { label: "Shuozhou (ShanXi)", value: "ShanXi,Shuozhou" },
  { label: "Siping (JiLin)", value: "JiLin,Siping" },
  { label: "Songyuan (JiLin)", value: "JiLin,Songyuan" },
  { label: "Suihua (HeiLongJiang)", value: "HeiLongJiang,Suihua" },
  { label: "Suining (SiChuan)", value: "SiChuan,Suining" },
  { label: "Suizhou (HuBei)", value: "HuBei,Suizhou" },
  { label: "Suqian (JiangSu)", value: "JiangSu,Suqian" },
  { label: "Suzhou (AnHui)", value: "AnHui,Suzhou" },
  { label: "Suzhou (JiangSu)", value: "JiangSu,Suzhou" },
  { label: "Tacheng (XinJiang)", value: "XinJiang,Tacheng" },
  { label: "Tai'an (ShanDong)", value: "ShanDong,Tai'an" },
  { label: "Taibei (TaiWan)", value: "TaiWan,Taibei" },
  { label: "Taidong (TaiWan)", value: "TaiWan,Taidong" },
  { label: "Tainan (TaiWan)", value: "TaiWan,Tainan" },
  { label: "Taiyuan (ShanXi)", value: "ShanXi,Taiyuan" },
  { label: "Taizhong (TaiWan)", value: "TaiWan,Taizhong" },
  { label: "Taizhou (ZheJiang)", value: "ZheJiang,Taizhou" },
  { label: "Taizhou (JiangSu)", value: "JiangSu,Taizhou" },
  { label: "Tangshan (HeBei)", value: "HeBei,Tangshan" },
  { label: "Taoyuan (TaiWan)", value: "TaiWan,Taoyuan" },
  { label: "Tianjin (TianJin)", value: "TianJin,Tianjin" },
  { label: "Tianmen (HuBei)", value: "HuBei,Tianmen" },
  { label: "Tianshui (GanSu)", value: "GanSu,Tianshui" },
  { label: "Tieling (LiaoNing)", value: "LiaoNing,Tieling" },
  { label: "tiemenguan Shi (XinJiang)", value: "XinJiang,tiemenguan Shi" },
  { label: "Tongchuan (ShaanXi)", value: "ShaanXi,Tongchuan" },
  { label: "Tonghua (JiLin)", value: "JiLin,Tonghua" },
  { label: "Tongliao (NeiMengGu)", value: "NeiMengGu,Tongliao" },
  { label: "Tongling (AnHui)", value: "AnHui,Tongling" },
  { label: "Tongren (GuiZhou)", value: "GuiZhou,Tongren" },
  { label: "Tumushuke Shi (XinJiang)", value: "XinJiang,Tumushuke Shi" },
  { label: "Tunchang Xian (HaiNan)", value: "HaiNan,Tunchang Xian" },
  { label: "Turpan (XinJiang)", value: "XinJiang,Turpan" },
  { label: "Ulanqab (NeiMengGu)", value: "NeiMengGu,Ulanqab" },
  { label: "ürümqi (XinJiang)", value: "XinJiang,ürümqi" },
  { label: "Wanning Qu", value: "Wanning Qu" },
  { label: "Weifang (ShanDong)", value: "ShanDong,Weifang" },
  { label: "Weihai (ShanDong)", value: "ShanDong,Weihai" },
  { label: "Weinan (ShaanXi)", value: "ShaanXi,Weinan" },
  { label: "Wenchang Qu (HaiNan)", value: "HaiNan,Wenchang Qu" },
  { label: "Wenshan (YunNan)", value: "YunNan,Wenshan" },
  { label: "Wenzhou (ZheJiang)", value: "ZheJiang,Wenzhou" },
  { label: "Wuhai (NeiMengGu)", value: "NeiMengGu,Wuhai" },
  { label: "Wuhan (HuBei)", value: "HuBei,Wuhan" },
  { label: "Wuhu (AnHui)", value: "AnHui,Wuhu" },
  { label: "wujiaqu Shi (XinJiang)", value: "XinJiang,wujiaqu Shi" },
  { label: "Wuwei (GanSu)", value: "GanSu,Wuwei" },
  { label: "Wuxi (JiangSu)", value: "JiangSu,Wuxi" },
  { label: "Wuzhishan   Shi (HaiNan)", value: "HaiNan,Wuzhishan   Shi" },
  { label: "Wuzhong (NingXia)", value: "NingXia,Wuzhong" },
  { label: "Wuzhou (GuangXi)", value: "GuangXi,Wuzhou" },
  { label: "Xi'an (ShaanXi)", value: "ShaanXi,Xi'an" },
  { label: "Xiamen (FuJian)", value: "FuJian,Xiamen" },
  { label: "Xiangfan (HuBei)", value: "HuBei,Xiangfan" },
  { label: "Xiangtan (HuNan)", value: "HuNan,Xiangtan" },
  { label: "Xiangxi (HuNan)", value: "HuNan,Xiangxi" },
  { label: "Xianning (HuBei)", value: "HuBei,Xianning" },
  { label: "Xiantao (HuBei)", value: "HuBei,Xiantao" },
  { label: "Xianyang (ShaanXi)", value: "ShaanXi,Xianyang" },
  { label: "Xiaogan (HuBei)", value: "HuBei,Xiaogan" },
  { label: "Xigazê (XiZang)", value: "XiZang,Xigazê" },
  { label: "Xilin Gol Meng (NeiMengGu)", value: "NeiMengGu,Xilin Gol Meng" },
  { label: "Xingan Meng (NeiMengGu)", value: "NeiMengGu,Xingan Meng" },
  { label: "Xingtai (HeBei)", value: "HeBei,Xingtai" },
  { label: "Xining (QingHai)", value: "QingHai,Xining" },
  { label: "Xinjie (HongKong)", value: "HongKong,Xinjie" },
  { label: "Xinxiang (HeNan)", value: "HeNan,Xinxiang" },
  { label: "Xinxing Shi (XinJiang)", value: "XinJiang,Xinxing Shi" },
  { label: "Xinyang (HeNan)", value: "HeNan,Xinyang" },
  { label: "Xinyu (JiangXi)", value: "JiangXi,Xinyu" },
  { label: "Xinzhou (ShanXi)", value: "ShanXi,Xinzhou" },
  { label: "Xinzhu (TaiWan)", value: "TaiWan,Xinzhu" },
  { label: "Xishuangbanna (YunNan)", value: "YunNan,Xishuangbanna" },
  { label: "Xuancheng (AnHui)", value: "AnHui,Xuancheng" },
  { label: "Xuchang (HeNan)", value: "HeNan,Xuchang" },
  { label: "Xuzhou (JiangSu)", value: "JiangSu,Xuzhou" },
  { label: "Ya'an (SiChuan)", value: "SiChuan,Ya'an" },
  { label: "Yan'an (ShaanXi)", value: "ShaanXi,Yan'an" },
  { label: "Yanbian (JiLin)", value: "JiLin,Yanbian" },
  { label: "Yancheng (JiangSu)", value: "JiangSu,Yancheng" },
  { label: "Yangjiang (GuangDong)", value: "GuangDong,Yangjiang" },
  { label: "Yangquan (ShanXi)", value: "ShanXi,Yangquan" },
  { label: "Yangzhou (JiangSu)", value: "JiangSu,Yangzhou" },
  { label: "Yantai (ShanDong)", value: "ShanDong,Yantai" },
  { label: "Yibin (SiChuan)", value: "SiChuan,Yibin" },
  { label: "Yichang (HuBei)", value: "HuBei,Yichang" },
  { label: "Yichun (HeiLongJiang)", value: "HeiLongJiang,Yichun" },
  { label: "Yichun (JiangXi)", value: "JiangXi,Yichun" },
  { label: "Yilan (TaiWan)", value: "TaiWan,Yilan" },
  { label: "Yinchuan (NingXia)", value: "NingXia,Yinchuan" },
  { label: "Yingkou (LiaoNing)", value: "LiaoNing,Yingkou" },
  { label: "Yingtan (JiangXi)", value: "JiangXi,Yingtan" },
  { label: "Yiyang (HuNan)", value: "HuNan,Yiyang" },
  { label: "Yongzhou (HuNan)", value: "HuNan,Yongzhou" },
  { label: "Yueyang (HuNan)", value: "HuNan,Yueyang" },
  { label: "Yulin (ShaanXi)", value: "ShaanXi,Yulin" },
  { label: "Yulin (GuangXi)", value: "GuangXi,Yulin" },
  { label: "Yuncheng (ShanXi)", value: "ShanXi,Yuncheng" },
  { label: "Yunfu (GuangDong)", value: "GuangDong,Yunfu" },
  { label: "Yunlin (TaiWan)", value: "TaiWan,Yunlin" },
  { label: "Yushu (QingHai)", value: "QingHai,Yushu" },
  { label: "Yuxi (YunNan)", value: "YunNan,Yuxi" },
  { label: "Zaozhuang (ShanDong)", value: "ShanDong,Zaozhuang" },
  { label: "Zhanghua (TaiWan)", value: "TaiWan,Zhanghua" },
  { label: "Zhangjiajie (HuNan)", value: "HuNan,Zhangjiajie" },
  { label: "Zhangjiakou (HeBei)", value: "HeBei,Zhangjiakou" },
  { label: "Zhangye (GanSu)", value: "GanSu,Zhangye" },
  { label: "Zhangzhou (FuJian)", value: "FuJian,Zhangzhou" },
  { label: "Zhanjiang (GuangDong)", value: "GuangDong,Zhanjiang" },
  { label: "Zhaoqing (GuangDong)", value: "GuangDong,Zhaoqing" },
  { label: "Zhaotong (YunNan)", value: "YunNan,Zhaotong" },
  { label: "Zhengzhou (HeNan)", value: "HeNan,Zhengzhou" },
  { label: "Zhenjiang (JiangSu)", value: "JiangSu,Zhenjiang" },
  { label: "Zhongshan (GuangDong)", value: "GuangDong,Zhongshan" },
  { label: "Zhongwei (NingXia)", value: "NingXia,Zhongwei" },
  { label: "Zhoukou (HeNan)", value: "HeNan,Zhoukou" },
  { label: "Zhoushan (ZheJiang)", value: "ZheJiang,Zhoushan" },
  { label: "Zhuhai (GuangDong)", value: "GuangDong,Zhuhai" },
  { label: "Zhumadian (HeNan)", value: "HeNan,Zhumadian" },
  { label: "Zhuzhou (HuNan)", value: "HuNan,Zhuzhou" },
  { label: "Zibo (ShanDong)", value: "ShanDong,Zibo" },
  { label: "Zigong (SiChuan)", value: "SiChuan,Zigong" },
  { label: "Ziyang (SiChuan)", value: "SiChuan,Ziyang" },
  { label: "Zunyi (GuiZhou)", value: "GuiZhou,Zunyi" }
]

export const CN_CITIES_BY_PROVINCE: { [province: string]: selectOption[] } = {
  "SiChuan": [
    { label: "Aba", value: "SiChuan,Aba" },
    { label: "Bazhong", value: "SiChuan,Bazhong" },
    { label: "Chengdu", value: "SiChuan,Chengdu" },
    { label: "Dazhou", value: "SiChuan,Dazhou" },
    { label: "Deyang", value: "SiChuan,Deyang" },
    { label: "Garzê", value: "SiChuan,Garzê" },
    { label: "Guangan", value: "SiChuan,Guangan" },
    { label: "Guangyuan", value: "SiChuan,Guangyuan" },
    { label: "Leshan", value: "SiChuan,Leshan" },
    { label: "Liangshan", value: "SiChuan,Liangshan" },
    { label: "Luzhou", value: "SiChuan,Luzhou" },
    { label: "Meishan", value: "SiChuan,Meishan" },
    { label: "Mianyang", value: "SiChuan,Mianyang" },
    { label: "Nanchong", value: "SiChuan,Nanchong" },
    { label: "Neijiang", value: "SiChuan,Neijiang" },
    { label: "Panzhihua", value: "SiChuan,Panzhihua" },
    { label: "Suining", value: "SiChuan,Suining" },
    { label: "Ya'an", value: "SiChuan,Ya'an" },
    { label: "Yibin", value: "SiChuan,Yibin" },
    { label: "Zigong", value: "SiChuan,Zigong" },
    { label: "Ziyang", value: "SiChuan,Ziyang" }
  ],
  "XinJiang": [
    { label: "Aksu", value: "XinJiang,Aksu" },
    { label: "alaer Shi", value: "XinJiang,alaer Shi" },
    { label: "Altay", value: "XinJiang,Altay" },
    { label: "baiyang Shi", value: "XinJiang,baiyang Shi" },
    { label: "Bayingolin Mongol", value: "XinJiang,Bayingolin Mongol" },
    { label: "beitun Shi", value: "XinJiang,beitun Shi" },
    { label: "Bortala Mongol", value: "XinJiang,Bortala Mongol" },
    { label: "Changji", value: "XinJiang,Changji" },
    { label: "Hami", value: "XinJiang,Hami" },
    { label: "Hotan", value: "XinJiang,Hotan" },
    { label: "huyanghe Shi", value: "XinJiang,huyanghe Shi" },
    { label: "Ili Kazak", value: "XinJiang,Ili Kazak" },
    { label: "Karamay", value: "XinJiang,Karamay" },
    { label: "Kashi", value: "XinJiang,Kashi" },
    { label: "kekedala Shi", value: "XinJiang,kekedala Shi" },
    { label: "Kizilsu Kirgiz", value: "XinJiang,Kizilsu Kirgiz" },
    { label: "kunyu Shi", value: "XinJiang,kunyu Shi" },
    { label: "Shihezi Shi", value: "XinJiang,Shihezi Shi" },
    { label: "shuanghe Shi", value: "XinJiang,shuanghe Shi" },
    { label: "Tacheng", value: "XinJiang,Tacheng" },
    { label: "tiemenguan Shi", value: "XinJiang,tiemenguan Shi" },
    { label: "Tumushuke Shi", value: "XinJiang,Tumushuke Shi" },
    { label: "Turpan", value: "XinJiang,Turpan" },
    { label: "ürümqi", value: "XinJiang,ürümqi" },
    { label: "wujiaqu Shi", value: "XinJiang,wujiaqu Shi" },
    { label: "Xinxing Shi", value: "XinJiang,Xinxing Shi" }
  ],
  "NeiMengGu": [
    { label: "Alxa Meng", value: "NeiMengGu,Alxa Meng" },
    { label: "Baotou", value: "NeiMengGu,Baotou" },
    { label: "Bayannur", value: "NeiMengGu,Bayannur" },
    { label: "Chifeng", value: "NeiMengGu,Chifeng" },
    { label: "Hohhot", value: "NeiMengGu,Hohhot" },
    { label: "Hulun Buir", value: "NeiMengGu,Hulun Buir" },
    { label: "Ordos", value: "NeiMengGu,Ordos" },
    { label: "Tongliao", value: "NeiMengGu,Tongliao" },
    { label: "Ulanqab", value: "NeiMengGu,Ulanqab" },
    { label: "Wuhai", value: "NeiMengGu,Wuhai" },
    { label: "Xilin Gol Meng", value: "NeiMengGu,Xilin Gol Meng" },
    { label: "Xingan Meng", value: "NeiMengGu,Xingan Meng" }
  ],
  "ShaanXi": [
    { label: "AnKang", value: "ShaanXi,AnKang" },
    { label: "Baoji", value: "ShaanXi,Baoji" },
    { label: "Hanzhong", value: "ShaanXi,Hanzhong" },
    { label: "Shangluo", value: "ShaanXi,Shangluo" },
    { label: "Tongchuan", value: "ShaanXi,Tongchuan" },
    { label: "Weinan", value: "ShaanXi,Weinan" },
    { label: "Xi'an", value: "ShaanXi,Xi'an" },
    { label: "Xianyang", value: "ShaanXi,Xianyang" },
    { label: "Yan'an", value: "ShaanXi,Yan'an" },
    { label: "Yulin", value: "ShaanXi,Yulin" }
  ],
  "AnHui": [
    { label: "Anqing", value: "AnHui,Anqing" },
    { label: "Bengbu", value: "AnHui,Bengbu" },
    { label: "Bozhou", value: "AnHui,Bozhou" },
    { label: "Chizhou", value: "AnHui,Chizhou" },
    { label: "Chuzhou", value: "AnHui,Chuzhou" },
    { label: "Fuyang", value: "AnHui,Fuyang" },
    { label: "Hefei", value: "AnHui,Hefei" },
    { label: "Huaibei", value: "AnHui,Huaibei" },
    { label: "Huainan", value: "AnHui,Huainan" },
    { label: "Huangshan", value: "AnHui,Huangshan" },
    { label: "Lu'an", value: "AnHui,Lu'an" },
    { label: "Ma'anshan", value: "AnHui,Ma'anshan" },
    { label: "Suzhou", value: "AnHui,Suzhou" },
    { label: "Tongling", value: "AnHui,Tongling" },
    { label: "Wuhu", value: "AnHui,Wuhu" },
    { label: "Xuancheng", value: "AnHui,Xuancheng" }
  ],
  "LiaoNing": [
    { label: "Anshan", value: "LiaoNing,Anshan" },
    { label: "Benxi", value: "LiaoNing,Benxi" },
    { label: "Chaoyang", value: "LiaoNing,Chaoyang" },
    { label: "Dalian", value: "LiaoNing,Dalian" },
    { label: "Dandong", value: "LiaoNing,Dandong" },
    { label: "Fushun", value: "LiaoNing,Fushun" },
    { label: "Fuxin", value: "LiaoNing,Fuxin" },
    { label: "Huludao", value: "LiaoNing,Huludao" },
    { label: "Jinzhou", value: "LiaoNing,Jinzhou" },
    { label: "Liaoyang", value: "LiaoNing,Liaoyang" },
    { label: "Panjin", value: "LiaoNing,Panjin" },
    { label: "Shenyang", value: "LiaoNing,Shenyang" },
    { label: "Tieling", value: "LiaoNing,Tieling" },
    { label: "Yingkou", value: "LiaoNing,Yingkou" }
  ],
  "GuiZhou": [
    { label: "Anshun", value: "GuiZhou,Anshun" },
    { label: "Bijie", value: "GuiZhou,Bijie" },
    { label: "Guiyang", value: "GuiZhou,Guiyang" },
    { label: "Liupanshui", value: "GuiZhou,Liupanshui" },
    { label: "Qiandongnan", value: "GuiZhou,Qiandongnan" },
    { label: "Qiannan", value: "GuiZhou,Qiannan" },
    { label: "Qianxinan", value: "GuiZhou,Qianxinan" },
    { label: "Qianxi Shi", value: "GuiZhou,Qianxi Shi" },
    { label: "Tongren", value: "GuiZhou,Tongren" },
    { label: "Zunyi", value: "GuiZhou,Zunyi" }
  ],
  "HeNan": [
    { label: "Anyang", value: "HeNan,Anyang" },
    { label: "Hebi", value: "HeNan,Hebi" },
    { label: "Jiaozuo", value: "HeNan,Jiaozuo" },
    { label: "Jiyuan", value: "HeNan,Jiyuan" },
    { label: "Kaifeng", value: "HeNan,Kaifeng" },
    { label: "Luohe", value: "HeNan,Luohe" },
    { label: "Luoyang", value: "HeNan,Luoyang" },
    { label: "Nanyang", value: "HeNan,Nanyang" },
    { label: "Pingdingshan", value: "HeNan,Pingdingshan" },
    { label: "Puyang", value: "HeNan,Puyang" },
    { label: "Sanmenxia", value: "HeNan,Sanmenxia" },
    { label: "Shangqiu", value: "HeNan,Shangqiu" },
    { label: "Xinxiang", value: "HeNan,Xinxiang" },
    { label: "Xinyang", value: "HeNan,Xinyang" },
    { label: "Xuchang", value: "HeNan,Xuchang" },
    { label: "Zhengzhou", value: "HeNan,Zhengzhou" },
    { label: "Zhoukou", value: "HeNan,Zhoukou" },
    { label: "Zhumadian", value: "HeNan,Zhumadian" }
  ],
  "JiLin": [
    { label: "Baicheng", value: "JiLin,Baicheng" },
    { label: "Baishan", value: "JiLin,Baishan" },
    { label: "Changchun", value: "JiLin,Changchun" },
    { label: "Jilin", value: "JiLin,Jilin" },
    { label: "Liaoyuan", value: "JiLin,Liaoyuan" },
    { label: "Siping", value: "JiLin,Siping" },
    { label: "Songyuan", value: "JiLin,Songyuan" },
    { label: "Tonghua", value: "JiLin,Tonghua" },
    { label: "Yanbian", value: "JiLin,Yanbian" }
  ],
  "HaiNan": [
    { label: "Baisha Lizu Zizhixian", value: "HaiNan,Baisha Lizu Zizhixian" },
    { label: "Baoting Lizu Miaozu Zizhixian", value: "HaiNan,Baoting Lizu Miaozu Zizhixian" },
    { label: "Changjiang Lizu Zizhixian", value: "HaiNan,Changjiang Lizu Zizhixian" },
    { label: "Chengmai Qu", value: "HaiNan,Chengmai Qu" },
    { label: "Danzhou Shi", value: "HaiNan,Danzhou Shi" },
    { label: "Dingan Xian", value: "HaiNan,Dingan Xian" },
    { label: "Dongfang  Shi", value: "HaiNan,Dongfang  Shi" },
    { label: "Haikou", value: "HaiNan,Haikou" },
    { label: "Ledong Lizu Zizhixian", value: "HaiNan,Ledong Lizu Zizhixian" },
    { label: "Lingao Xian", value: "HaiNan,Lingao Xian" },
    { label: "Lingshui Lizu Zizhixian", value: "HaiNan,Lingshui Lizu Zizhixian" },
    { label: "Nansha", value: "HaiNan,Nansha" },
    { label: "Qionghai   Shi", value: "HaiNan,Qionghai   Shi" },
    { label: "Qiongzhong Lizu Miaozu Zizhixian", value: "HaiNan,Qiongzhong Lizu Miaozu Zizhixian" },
    { label: "Sanya", value: "HaiNan,Sanya" },
    { label: "Tunchang Xian", value: "HaiNan,Tunchang Xian" },
    { label: "Wenchang Qu", value: "HaiNan,Wenchang Qu" },
    { label: "Wuzhishan   Shi", value: "HaiNan,Wuzhishan   Shi" }
  ],
  "GanSu": [
    { label: "Baiyin", value: "GanSu,Baiyin" },
    { label: "Dingxi", value: "GanSu,Dingxi" },
    { label: "Gannan", value: "GanSu,Gannan" },
    { label: "Jiayuguan", value: "GanSu,Jiayuguan" },
    { label: "Jinchang", value: "GanSu,Jinchang" },
    { label: "Jiuquan", value: "GanSu,Jiuquan" },
    { label: "Lanzhou", value: "GanSu,Lanzhou" },
    { label: "Linxia", value: "GanSu,Linxia" },
    { label: "Longnan", value: "GanSu,Longnan" },
    { label: "Pingliang", value: "GanSu,Pingliang" },
    { label: "Qingyang", value: "GanSu,Qingyang" },
    { label: "Tianshui", value: "GanSu,Tianshui" },
    { label: "Wuwei", value: "GanSu,Wuwei" },
    { label: "Zhangye", value: "GanSu,Zhangye" }
  ],
  "HeBei": [
    { label: "Baoding", value: "HeBei,Baoding" },
    { label: "Cangzhou", value: "HeBei,Cangzhou" },
    { label: "Chengde", value: "HeBei,Chengde" },
    { label: "Handan", value: "HeBei,Handan" },
    { label: "Hengshui", value: "HeBei,Hengshui" },
    { label: "Langfang", value: "HeBei,Langfang" },
    { label: "Qinhuangdao", value: "HeBei,Qinhuangdao" },
    { label: "Shijiazhuang", value: "HeBei,Shijiazhuang" },
    { label: "Tangshan", value: "HeBei,Tangshan" },
    { label: "Xingtai", value: "HeBei,Xingtai" },
    { label: "Zhangjiakou", value: "HeBei,Zhangjiakou" }
  ],
  "YunNan": [
    { label: "Baoshan", value: "YunNan,Baoshan" },
    { label: "Chuxiong", value: "YunNan,Chuxiong" },
    { label: "Dali", value: "YunNan,Dali" },
    { label: "Dehong", value: "YunNan,Dehong" },
    { label: "Dêqên", value: "YunNan,Dêqên" },
    { label: "Honghe", value: "YunNan,Honghe" },
    { label: "Kunming", value: "YunNan,Kunming" },
    { label: "Lijiang", value: "YunNan,Lijiang" },
    { label: "Lincang", value: "YunNan,Lincang" },
    { label: "Nujiang", value: "YunNan,Nujiang" },
    { label: "Pu'er", value: "YunNan,Pu'er" },
    { label: "Qujing", value: "YunNan,Qujing" },
    { label: "Wenshan", value: "YunNan,Wenshan" },
    { label: "Xishuangbanna", value: "YunNan,Xishuangbanna" },
    { label: "Yuxi", value: "YunNan,Yuxi" },
    { label: "Zhaotong", value: "YunNan,Zhaotong" }
  ],
  "GuangXi": [
    { label: "Beihai", value: "GuangXi,Beihai" },
    { label: "Bose", value: "GuangXi,Bose" },
    { label: "Chongzuo", value: "GuangXi,Chongzuo" },
    { label: "Fangchenggang", value: "GuangXi,Fangchenggang" },
    { label: "Guigang", value: "GuangXi,Guigang" },
    { label: "Guilin", value: "GuangXi,Guilin" },
    { label: "Hechi", value: "GuangXi,Hechi" },
    { label: "Hezhou", value: "GuangXi,Hezhou" },
    { label: "Laibin", value: "GuangXi,Laibin" },
    { label: "Liuzhou", value: "GuangXi,Liuzhou" },
    { label: "Nanning", value: "GuangXi,Nanning" },
    { label: "Qinzhou", value: "GuangXi,Qinzhou" },
    { label: "Wuzhou", value: "GuangXi,Wuzhou" },
    { label: "Yulin", value: "GuangXi,Yulin" }
  ],
  "BeiJing": [
    { label: "Beijing", value: "BeiJing,Beijing" }
  ],
  "ShanDong": [
    { label: "Binzhou", value: "ShanDong,Binzhou" },
    { label: "Dezhou", value: "ShanDong,Dezhou" },
    { label: "Dongying", value: "ShanDong,Dongying" },
    { label: "Heze", value: "ShanDong,Heze" },
    { label: "Jinan", value: "ShanDong,Jinan" },
    { label: "Jining", value: "ShanDong,Jining" },
    { label: "Liaocheng", value: "ShanDong,Liaocheng" },
    { label: "Linyi", value: "ShanDong,Linyi" },
    { label: "Qingdao", value: "ShanDong,Qingdao" },
    { label: "Rizhao", value: "ShanDong,Rizhao" },
    { label: "Tai'an", value: "ShanDong,Tai'an" },
    { label: "Weifang", value: "ShanDong,Weifang" },
    { label: "Weihai", value: "ShanDong,Weihai" },
    { label: "Yantai", value: "ShanDong,Yantai" },
    { label: "Zaozhuang", value: "ShanDong,Zaozhuang" },
    { label: "Zibo", value: "ShanDong,Zibo" }
  ],
  "HuNan": [
    { label: "Changde", value: "HuNan,Changde" },
    { label: "Changsha", value: "HuNan,Changsha" },
    { label: "Chenzhou", value: "HuNan,Chenzhou" },
    { label: "Hengyang", value: "HuNan,Hengyang" },
    { label: "Huaihua", value: "HuNan,Huaihua" },
    { label: "Loudi", value: "HuNan,Loudi" },
    { label: "Shaoyang", value: "HuNan,Shaoyang" },
    { label: "Xiangtan", value: "HuNan,Xiangtan" },
    { label: "Xiangxi", value: "HuNan,Xiangxi" },
    { label: "Yiyang", value: "HuNan,Yiyang" },
    { label: "Yongzhou", value: "HuNan,Yongzhou" },
    { label: "Yueyang", value: "HuNan,Yueyang" },
    { label: "Zhangjiajie", value: "HuNan,Zhangjiajie" },
    { label: "Zhuzhou", value: "HuNan,Zhuzhou" }
  ],
  "ShanXi": [
    { label: "Changzhi", value: "ShanXi,Changzhi" },
    { label: "Datong", value: "ShanXi,Datong" },
    { label: "Jincheng", value: "ShanXi,Jincheng" },
    { label: "Jinzhong", value: "ShanXi,Jinzhong" },
    { label: "Linfen", value: "ShanXi,Linfen" },
    { label: "Lüliang", value: "ShanXi,Lüliang" },
    { label: "Shuozhou", value: "ShanXi,Shuozhou" },
    { label: "Taiyuan", value: "ShanXi,Taiyuan" },
    { label: "Xinzhou", value: "ShanXi,Xinzhou" },
    { label: "Yangquan", value: "ShanXi,Yangquan" },
    { label: "Yuncheng", value: "ShanXi,Yuncheng" }
  ],
  "JiangSu": [
    { label: "Changzhou", value: "JiangSu,Changzhou" },
    { label: "Huai'an", value: "JiangSu,Huai'an" },
    { label: "Lianyungang", value: "JiangSu,Lianyungang" },
    { label: "Nanjing", value: "JiangSu,Nanjing" },
    { label: "Nantong", value: "JiangSu,Nantong" },
    { label: "Suqian", value: "JiangSu,Suqian" },
    { label: "Suzhou", value: "JiangSu,Suzhou" },
    { label: "Taizhou", value: "JiangSu,Taizhou" },
    { label: "Wuxi", value: "JiangSu,Wuxi" },
    { label: "Xuzhou", value: "JiangSu,Xuzhou" },
    { label: "Yancheng", value: "JiangSu,Yancheng" },
    { label: "Yangzhou", value: "JiangSu,Yangzhou" },
    { label: "Zhenjiang", value: "JiangSu,Zhenjiang" }
  ],
  "GuangDong": [
    { label: "Chaozhou", value: "GuangDong,Chaozhou" },
    { label: "Dongguan", value: "GuangDong,Dongguan" },
    { label: "Foshan", value: "GuangDong,Foshan" },
    { label: "Guangzhou", value: "GuangDong,Guangzhou" },
    { label: "Heyuan", value: "GuangDong,Heyuan" },
    { label: "Huizhou", value: "GuangDong,Huizhou" },
    { label: "Jiangmen", value: "GuangDong,Jiangmen" },
    { label: "Jieyang", value: "GuangDong,Jieyang" },
    { label: "Maoming", value: "GuangDong,Maoming" },
    { label: "Meizhou", value: "GuangDong,Meizhou" },
    { label: "Qingyuan", value: "GuangDong,Qingyuan" },
    { label: "Shantou", value: "GuangDong,Shantou" },
    { label: "Shanwei", value: "GuangDong,Shanwei" },
    { label: "Shaoguan", value: "GuangDong,Shaoguan" },
    { label: "Shenzhen", value: "GuangDong,Shenzhen" },
    { label: "Yangjiang", value: "GuangDong,Yangjiang" },
    { label: "Yunfu", value: "GuangDong,Yunfu" },
    { label: "Zhanjiang", value: "GuangDong,Zhanjiang" },
    { label: "Zhaoqing", value: "GuangDong,Zhaoqing" },
    { label: "Zhongshan", value: "GuangDong,Zhongshan" },
    { label: "Zhuhai", value: "GuangDong,Zhuhai" }
  ],
  "ChongQing": [
    { label: "Chongqing", value: "ChongQing,Chongqing" }
  ],
  "HeiLongJiang": [
    { label: "Da Hinggan Ling", value: "HeiLongJiang,Da Hinggan Ling" },
    { label: "Daqing", value: "HeiLongJiang,Daqing" },
    { label: "Harbin", value: "HeiLongJiang,Harbin" },
    { label: "Hegang", value: "HeiLongJiang,Hegang" },
    { label: "Heihe", value: "HeiLongJiang,Heihe" },
    { label: "Jiamusi", value: "HeiLongJiang,Jiamusi" },
    { label: "Jixi", value: "HeiLongJiang,Jixi" },
    { label: "MudanJiang", value: "HeiLongJiang,MudanJiang" },
    { label: "Qiqihar", value: "HeiLongJiang,Qiqihar" },
    { label: "QitaiHe", value: "HeiLongJiang,QitaiHe" },
    { label: "ShuangyaShan", value: "HeiLongJiang,ShuangyaShan" },
    { label: "Suihua", value: "HeiLongJiang,Suihua" },
    { label: "Yichun", value: "HeiLongJiang,Yichun" }
  ],
  "HuBei": [
    { label: "Enshi", value: "HuBei,Enshi" },
    { label: "Ezhou", value: "HuBei,Ezhou" },
    { label: "Huanggang", value: "HuBei,Huanggang" },
    { label: "Huangshi", value: "HuBei,Huangshi" },
    { label: "Jingmen", value: "HuBei,Jingmen" },
    { label: "Jingzhou", value: "HuBei,Jingzhou" },
    { label: "Qianjiang", value: "HuBei,Qianjiang" },
    { label: "Shennongjia", value: "HuBei,Shennongjia" },
    { label: "Shiyan", value: "HuBei,Shiyan" },
    { label: "Suizhou", value: "HuBei,Suizhou" },
    { label: "Tianmen", value: "HuBei,Tianmen" },
    { label: "Wuhan", value: "HuBei,Wuhan" },
    { label: "Xiangfan", value: "HuBei,Xiangfan" },
    { label: "Xianning", value: "HuBei,Xianning" },
    { label: "Xiantao", value: "HuBei,Xiantao" },
    { label: "Xiaogan", value: "HuBei,Xiaogan" },
    { label: "Yichang", value: "HuBei,Yichang" }
  ],
  "JiangXi": [
    { label: "Fuzhou", value: "JiangXi,Fuzhou" },
    { label: "Ganzhou", value: "JiangXi,Ganzhou" },
    { label: "Ji'an", value: "JiangXi,Ji'an" },
    { label: "Jingdezhen", value: "JiangXi,Jingdezhen" },
    { label: "Jiujiang", value: "JiangXi,Jiujiang" },
    { label: "Nanchang", value: "JiangXi,Nanchang" },
    { label: "Pingxiang", value: "JiangXi,Pingxiang" },
    { label: "Shangrao", value: "JiangXi,Shangrao" },
    { label: "Xinyu", value: "JiangXi,Xinyu" },
    { label: "Yichun", value: "JiangXi,Yichun" },
    { label: "Yingtan", value: "JiangXi,Yingtan" }
  ],
  "FuJian": [
    { label: "Fuzhou", value: "FuJian,Fuzhou" },
    { label: "Longyan", value: "FuJian,Longyan" },
    { label: "Nanping", value: "FuJian,Nanping" },
    { label: "Ningde", value: "FuJian,Ningde" },
    { label: "Putian", value: "FuJian,Putian" },
    { label: "Quanzhou", value: "FuJian,Quanzhou" },
    { label: "Sanming", value: "FuJian,Sanming" },
    { label: "Xiamen", value: "FuJian,Xiamen" },
    { label: "Zhangzhou", value: "FuJian,Zhangzhou" }
  ],
  "TaiWan": [
    { label: "Gaoxiong", value: "TaiWan,Gaoxiong" },
    { label: "Hualian", value: "TaiWan,Hualian" },
    { label: "Jiayi", value: "TaiWan,Jiayi" },
    { label: "Jilong", value: "TaiWan,Jilong" },
    { label: "Miaosu", value: "TaiWan,Miaosu" },
    { label: "Nantou", value: "TaiWan,Nantou" },
    { label: "Penghu", value: "TaiWan,Penghu" },
    { label: "Pingdong", value: "TaiWan,Pingdong" },
    { label: "Taibei", value: "TaiWan,Taibei" },
    { label: "Taidong", value: "TaiWan,Taidong" },
    { label: "Tainan", value: "TaiWan,Tainan" },
    { label: "Taizhong", value: "TaiWan,Taizhong" },
    { label: "Taoyuan", value: "TaiWan,Taoyuan" },
    { label: "Xinzhu", value: "TaiWan,Xinzhu" },
    { label: "Yilan", value: "TaiWan,Yilan" },
    { label: "Yunlin", value: "TaiWan,Yunlin" },
    { label: "Zhanghua", value: "TaiWan,Zhanghua" }
  ],
  "QingHai": [
    { label: "Golog", value: "QingHai,Golog" },
    { label: "Haibei", value: "QingHai,Haibei" },
    { label: "Haidong", value: "QingHai,Haidong" },
    { label: "Hainan", value: "QingHai,Hainan" },
    { label: "Haixi", value: "QingHai,Haixi" },
    { label: "Huangnan", value: "QingHai,Huangnan" },
    { label: "Xining", value: "QingHai,Xining" },
    { label: "Yushu", value: "QingHai,Yushu" }
  ],
  "NingXia": [
    { label: "Guyuan", value: "NingXia,Guyuan" },
    { label: "Shizuishan", value: "NingXia,Shizuishan" },
    { label: "Wuzhong", value: "NingXia,Wuzhong" },
    { label: "Yinchuan", value: "NingXia,Yinchuan" },
    { label: "Zhongwei", value: "NingXia,Zhongwei" }
  ],
  "ZheJiang": [
    { label: "Hangzhou", value: "ZheJiang,Hangzhou" },
    { label: "Huzhou", value: "ZheJiang,Huzhou" },
    { label: "Jiaxing", value: "ZheJiang,Jiaxing" },
    { label: "Jinhua", value: "ZheJiang,Jinhua" },
    { label: "Lishui", value: "ZheJiang,Lishui" },
    { label: "Ningbo", value: "ZheJiang,Ningbo" },
    { label: "Quzhou", value: "ZheJiang,Quzhou" },
    { label: "Shaoxing", value: "ZheJiang,Shaoxing" },
    { label: "Taizhou", value: "ZheJiang,Taizhou" },
    { label: "Wenzhou", value: "ZheJiang,Wenzhou" },
    { label: "Zhoushan", value: "ZheJiang,Zhoushan" }
  ],
  "HongKong": [
    { label: "Hongkong Island", value: "HongKong,Hongkong Island" },
    { label: "Jiulong", value: "HongKong,Jiulong" },
    { label: "Xinjie", value: "HongKong,Xinjie" }
  ],
  "XiZang": [
    { label: "Lhasa", value: "XiZang,Lhasa" },
    { label: "Linzhi Shi", value: "XiZang,Linzhi Shi" },
    { label: "Nagqu", value: "XiZang,Nagqu" },
    { label: "Ngari", value: "XiZang,Ngari" },
    { label: "Qamdo", value: "XiZang,Qamdo" },
    { label: "Shannan", value: "XiZang,Shannan" },
    { label: "Xigazê", value: "XiZang,Xigazê" }
  ],
  "MaCao": [
    { label: "Macao", value: "MaCao,Macao" }
  ],
  "ShangHai": [
    { label: "Shanghai", value: "ShangHai,Shanghai" }
  ],
  "TianJin": [
    { label: "Tianjin", value: "TianJin,Tianjin" }
  ]
}

// Second-level mapping keyed by the city value. Add more cities here.
export const CN_DISTRICTS: { [city: string]: selectOption[] } = {
  "BeiJing,Beijing": [
    { label: "Chaoyang Qu", value: "BeiJing,Beijing,Chaoyang Qu" },
    { label: "Changping Qu", value: "BeiJing,Beijing,Changping Qu" },
    { label: "Shunyi Qu", value: "BeiJing,Beijing,Shunyi Qu" },
    { label: "Pinggu Qu", value: "BeiJing,Beijing,Pinggu Qu" },
    { label: "Tongzhou Qu", value: "BeiJing,Beijing,Tongzhou Qu" },
    { label: "Fengtai Qu", value: "BeiJing,Beijing,Fengtai Qu" },
    { label: "Fangshan Qu", value: "BeiJing,Beijing,Fangshan Qu" },
    { label: "Shijingshan Qu", value: "BeiJing,Beijing,Shijingshan Qu" },
    { label: "Yanqing  Qu", value: "BeiJing,Beijing,Yanqing  Qu" },
    { label: "Huairou Qu", value: "BeiJing,Beijing,Huairou Qu" },
    { label: "Miyun Qu", value: "BeiJing,Beijing,Miyun Qu" },
    { label: "Haidian Qu", value: "BeiJing,Beijing,Haidian Qu" },
    { label: "Dongcheng Qu", value: "BeiJing,Beijing,Dongcheng Qu" },
    { label: "Mentougou Qu", value: "BeiJing,Beijing,Mentougou Qu" },
    { label: "Xicheng Qu", value: "BeiJing,Beijing,Xicheng Qu" },
    { label: "Daxing Qu", value: "BeiJing,Beijing,Daxing Qu" }
  ]
}
